import { __extends } from "tslib";
import BSSAbstractComponent from '@main/view/components/bss-abstract-component/js/bss-abstract-component.js';
import { isEmpty } from 'lodash';
var BSSDynamicControlsComponent = /** @class */ (function (_super) {
    __extends(BSSDynamicControlsComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSDynamicControlsComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._prepareControlsDefaults();
        return _this;
    }
    /**
     * @desc prepare controls data defaults
     * @private
     */
    BSSDynamicControlsComponent.prototype._prepareControlsDefaults = function () {
        this._CONTROLS_RESULT_DATA_SOURCE = null;
        this._controlsData = {};
        this._productId = this.getProductId();
    };
    /**
     * @desc get controls data from resultData node
     * @returns {Object} parsed controls data from resultData node
     * @private
     */
    BSSDynamicControlsComponent.prototype._getControlsData = function () {
        var productResultData = this._config.resultData[this._productId] || null;
        var controlsResultData = (productResultData &&
            this._CONTROLS_RESULT_DATA_SOURCE &&
            productResultData[this._CONTROLS_RESULT_DATA_SOURCE]) ||
            null;
        return controlsResultData && JSON.parse(controlsResultData);
    };
    /**
     * @desc prepare output object with controls for recalculation
     * @returns {Object} stringified output object with controls for recalculation
     * @private
     */
    BSSDynamicControlsComponent.prototype._prepareOutputObjForRequest = function () {
        if (this._config.checkboxConfig.customValues &&
            Array.isArray(this._controlsData)) {
            this._controlsData = this._controlsData.map(function (controlData) {
                controlData.selected = controlData.checked;
                delete controlData.checked;
                delete controlData.description;
                delete controlData.value;
                delete controlData.component_code;
                delete controlData.label;
                return controlData;
            });
        }
        var controlsDataForRequest = !isEmpty(this._controlsData) && JSON.stringify(this._controlsData);
        if (controlsDataForRequest && this._CONTROLS_RESULT_DATA_SOURCE) {
            var obj = {};
            obj[this._CONTROLS_RESULT_DATA_SOURCE] = controlsDataForRequest;
            obj.triggerName = this._CONTROLS_RESULT_DATA_SOURCE;
            return obj;
        }
        return {};
    };
    /**
     * @desc trigger recalculation with controls output object
     * @private
     */
    BSSDynamicControlsComponent.prototype._triggerRecalculation = function () {
        var outputObj = this._prepareOutputObjForRequest();
        if (!isEmpty(outputObj)) {
            this._onOutputChange(outputObj);
        }
    };
    return BSSDynamicControlsComponent;
}(BSSAbstractComponent));
export default BSSDynamicControlsComponent;
